<template>
  <el-dialog
    :visible="visible"
    :z-index="13300"
    width="440px"
    custom-class="logout-confirm"
    :show-close="false"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    @close="cancel"
  >
    <div class="logout-confirm__head">
      <strong>退出登录</strong>
      <button type="button" aria-label="关闭" @click="cancel">×</button>
    </div>

    <div class="logout-confirm__content">
      <span class="logout-confirm__icon" aria-hidden="true">
        <i class="el-icon-warning-outline" />
      </span>
      <div>
        <strong>确定要退出当前账号吗？</strong>
        <p>退出后需要重新登录，才能继续查看和管理机器人及策略。</p>
      </div>
    </div>

    <div class="logout-confirm__actions">
      <button class="is-cancel" type="button" @click="cancel">取消</button>
      <button class="is-confirm" type="button" @click="$emit('confirm')">确定退出</button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LogoutConfirmModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.logout-confirm__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.logout-confirm__head strong {
  color: #182033;
  font-size: 18px;
  font-weight: 800;
}

.logout-confirm__head button {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  padding: 0;
  color: #8a90a0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.logout-confirm__head button:hover {
  color: #5f6573;
  background: #f5f6f9;
}

.logout-confirm__content {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 16px;
  border: 1px solid #ffe1dc;
  border-radius: 10px;
  background: #fff7f5;
}

.logout-confirm__icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: grid;
  place-items: center;
  color: #e5484d;
  border-radius: 50%;
  background: #ffe5e1;
  font-size: 18px;
}

.logout-confirm__content strong {
  display: block;
  margin: 1px 0 6px;
  color: #252b3b;
  font-size: 15px;
}

.logout-confirm__content p {
  margin: 0;
  color: #697083;
  font-size: 13px;
  line-height: 1.65;
}

.logout-confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.logout-confirm__actions button {
  min-width: 98px;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color .18s ease, background .18s ease, color .18s ease;
}

.logout-confirm__actions .is-cancel {
  color: #3a3f4e;
  border: 1px solid #dcdfe8;
  background: #fff;
}

.logout-confirm__actions .is-cancel:hover {
  color: #246bfd;
  border-color: #9bb8ff;
  background: #f7faff;
}

.logout-confirm__actions .is-confirm {
  color: #fff;
  border: 1px solid #e5484d;
  background: #e5484d;
}

.logout-confirm__actions .is-confirm:hover {
  border-color: #c93a3e;
  background: #c93a3e;
}
</style>

<style>
.logout-confirm {
  overflow: hidden;
  border-radius: 14px;
  box-shadow: 0 22px 60px rgba(25, 35, 58, .2);
}

.logout-confirm .el-dialog__header,
.logout-confirm .el-dialog__footer {
  display: none;
}

.logout-confirm .el-dialog__body {
  padding: 24px;
}
</style>
